import { DIRECTION } from '../enums/DIRECTION.js';
/** A 'Move' Event indicates that the node has been relocated in the DOM */
export default class Move extends CustomEvent {
    constructor(caller, direction = DIRECTION.UP, dur = 150) {
        super('move', {
            bubbles: false,
            detail: {
                caller,
                direction,
                dur
            }
        });
    }
}
export { DIRECTION };
